module.exports = "/static/images/yadkin-valley-wine-trail.png";